import "./dist/style.css"
import Uik from "./dist/index.es.js"

export default Uik